import { groq } from "next-sanity";

export const newsPathsQuery = groq`*[_type == "newsPages" && slug.current != null].slug.current`;
